<div>
    <div class="dialog-header">
        <img src="./assets/images/icons/dialog-warning.svg" />
    </div>
    <div class="dialog-body">
        <h4 class="alert-title">{{data.title}}</h4>
        <p class="message" [innerHtml]="data.message"></p>
    </div>
    <div class="reference-code" *ngIf="data.refNum" >
        <span class="ref-number">{{data.refNum}}</span>
        <img src="./assets/images/cob-copy.svg" alt="" (click)="shareInfo(data.refNum)">
    </div>
    <ng-container *ngIf="iscobStatus">
    <div class="dialog-footer">
        <button type="button" class="btn-link button-cancel" clickable (click)="cancel()"><span>{{ okLabel }}</span></button>
        <button type="button" class="button-common button30 cobConfirm" clickable (click)="ok()"><span>{{ cancelLabel }}</span></button>
    </div>
    </ng-container>
    <ng-container *ngIf="!iscobStatus">
        <div class="dialog-footer">
            <button type="button" class="btn-link button-cancel" clickable (click)="cancel()"><span>{{ okLabel }}</span></button>
            <button type="button" class="button-common button30" clickable (click)="ok()"><span>{{ cancelLabel }}</span></button>
        </div>
    </ng-container>
</div>
